import { Suspense, lazy } from 'react';

import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { scopes } from '@constants';
import { useAuth } from '@hooks';
import Login from '@pages/V2/Login';
import { FullPageLoader } from '@ui/full-page-loader';

// Lazy load role-based routes
const DisplayManagerRoutes = lazy(() => import('@routes/DisplayManagerRoutes'));
const WarehouseRoutes = lazy(() => import('@routes/WarehouseRoutes'));
const AdminRoutes = lazy(() => import('@routes/AdminRoutes'));

// 개발 환경에서 인증 테스트 도구 로드
if (process.env.NODE_ENV !== 'production') {
  import('@utils/authTestUtils');
}

function App() {
  const { roles, hasRole, isAuthenticated } = useAuth();

  // 로그인 페이지는 lazy 없이 즉시 렌더링 (로딩 인디케이터 방지)
  if (!isAuthenticated && window.location.pathname === '/login') {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <Suspense fallback={<FullPageLoader />}>
      {hasRole(scopes.ADMIN_DISPLAY_MANAGER) ? (
        <DisplayManagerRoutes />
      ) : hasRole(scopes.ADMIN_WAREHOUSE_MASTER) && roles.length === 2 ? (
        <WarehouseRoutes />
      ) : (
        <AdminRoutes />
      )}
    </Suspense>
  );
}

export default App;
